import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { TbEdit } from "react-icons/tb";
import api from "../../../api/axiosInstance";
const SchoolsList = (props) => {
  const [operatorSchools, setOperatorSchools] = useState([]);

  const columns = [
    {
      name: "School Name",
      selector: (row) => row.schoolName,
    },
    // {
    //   name: "Options",
    //   selector: (row) => (
    //     <>
    //       <button className="btn btn-sm btn-icon btn-primary cts-btn-primary mr-1">
    //         <TbEdit />
    //       </button>
    //     </>
    //   ),
    //   width: "80px"
    // },
  ];
  useEffect(() => {
    const getOperatorSchools = (operatorId) => {
      var config = {
        method: "Get",
        url:
          process.env.REACT_APP_API_URL +
          "Schools/GetOperatorSchools/" +
          operatorId,
        headers: {
          "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };

      api(config)
        .then(function (response) {
          if (response.data.statusCode === 200) {
            setOperatorSchools(response.data.content);
          }
        })
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            window.location = "/Login";
            window.location.reload();
          }
        });
    };
    getOperatorSchools(props.operatorId);
  }, []);

  return (
    <>
      <DataTable data={operatorSchools} columns={columns} />
    </>
  );
};

export default SchoolsList;
